import Flatpickr from "stimulus-flatpickr";

// import the translation files and create a translation mapping
import { French } from "flatpickr/dist/l10n/fr";
import { english } from "flatpickr/dist/l10n/default";
import { German } from "flatpickr/dist/l10n/de";

// create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {
  static classes = ["hover", "selected"];

  locales = {
    fr: French,
    en: english,
    de: German,
  };

  connect() {
    const rawDefaultDate = this.data.get("defaultDate");
    const rawMinDate = this.data.get("minDate");
    const rawMaxDate = this.data.get("maxDate");

    let parsedDefaultDate = rawDefaultDate;
    let parsedMinDate = rawMinDate;
    let parsedMaxDate = rawMaxDate;

    if (rawDefaultDate) {
      try {
        if (
          typeof rawDefaultDate === "string" &&
          rawDefaultDate.startsWith("[")
        ) {
          const dateStrings = JSON.parse(rawDefaultDate);
          parsedDefaultDate = dateStrings.map((str) => new Date(str));
        }
      } catch (e) {
        console.warn("Failed to parse defaultDate:", rawDefaultDate, e);
      }
    }

    if (rawMinDate && typeof rawMinDate === "string") {
      try {
        const cleaned = rawMinDate.replace(/^"+|"+$/g, "");
        parsedMinDate = new Date(cleaned);
      } catch (e) {
        console.warn("Failed to parse minDate:", rawMinDate, e);
      }
    }

    if (rawMaxDate && typeof rawMaxDate === "string") {
      try {
        const cleaned = rawMaxDate.replace(/^"+|"+$/g, "");
        parsedMaxDate = new Date(cleaned);
      } catch (e) {
        console.warn("Failed to parse maxDate:", rawMaxDate, e);
      }
    }

    this.element.removeAttribute("data-flatpickr-default-date");
    this.element.removeAttribute("data-flatpickr-min-date");
    this.element.removeAttribute("data-flatpickr-max-date");

    this.config = {
      locale: this.locale,
      altInput: true,
      dateFormat: "d.m.Y",
      altFormat: "d.m.Y",
      ...(parsedDefaultDate && { defaultDate: parsedDefaultDate }),
      ...(parsedMinDate && { minDate: parsedMinDate }),
      ...(parsedMaxDate && { maxDate: parsedMaxDate }),
      ...(this.data.get("mode") && { mode: this.data.get("mode") }),
    };

    super.connect();
  }

  change(selectedDates, dateStr, instance) {
    this.dispatch("change", {
      detail: {
        selectedDates,
        dateStr,
        instance,
      },
    });
  }

  get locale() {
    if (this.locales && this.data.has("locale")) {
      return this.locales[this.data.get("locale")];
    }
    return "";
  }

  dispatch(
    eventName,
    {
      target = this.element,
      detail = {},
      prefix = this.identifier,
      bubbles = true,
      cancelable = true,
    } = {}
  ) {
    const type = prefix ? `${prefix}:${eventName}` : eventName;
    const event = new CustomEvent(type, { detail, bubbles, cancelable });
    target.dispatchEvent(event);
    return event;
  }
}
